module.exports = __webpack_public_path__ + "img/gallery-4.81cb80a3.jpg";